<template>
  <div class="schedule-calendar-container" :class="{ 'is-folded': isFolded }">
    <!-- 使用遮罩方式，实现vant的calendar可切换上下月和选择月份 -->
    <div class="header-flex">
      <div class="top-nav van-hairline--bottom">
        <slot name="moreBtns"></slot> 
        <div style="display: flex;">

          <slot name="rightBtns"></slot>
        </div>
      </div>
      <div class="sub-title">
        <div class="date-operation-nav">
          <van-icon class-prefix="vxs-icon" name="system_choose" @click="nextMonth(-1)" size="16" />
          <div class="center-picker" @click="pickerTimeHandler">
            {{subtitle}}
          </div>
          <van-icon class-prefix="vxs-icon" name="system_choose" @click="nextMonth(1)" />
        </div>
        <div 
          class="to-day-btns" 
          :class="{
            'is-today': app.tool.date.formatDatetime(chooseDate, 'yyyy-MM-dd') === app.tool.date.formatDatetime(toDayDate, 'yyyy-MM-dd')
            }" 
          @click="backToDefaultDate">
          回到今天
        </div> 
      </div>

    </div>

    <!--日历组件-->
    <van-calendar
      class="schedule-vant-calendar"
      lazy-render
      :value="true"
      :defaultDate="defaultDate"
      :poppable="false"
      :show-confirm="false"
      :show-mark="false"
      :show-title="false"
      :formatter="formatter"
      :min-date="minDate"
      :max-date="maxDate"
      :row-height="rowHeight"
      :style="{ height: 'auto' }"
      @select="dateSelectHandler"
      ref="calendar"
    >
    </van-calendar>

    <!--折叠日历按钮-->
    <div class="fold-nav" @click="doFold()"></div>

  </div>
</template>

<script>

/**
 * 对vant日历组件的一个封装。
 * 实现可切换上下月、弹窗选择月份、折叠收起日历、显示事件提示小点。
 * 
 * 作为老师端/家长端课表的日历公共组件。
 * 该组件不负责数据请求，只根据接收的数据显示事件提示小点。
 * 
 * 向上响应chooseDate事件，表示选中日期发生改变，并传入选中日期值(Date类型)。
 * 向上响应monthChangeg事件，表示修改月份，并传入选中月份'YYYY-MM'格式字符串。
 */
export default {
  name: "scheduleCalendar",
  props: {
    // 日历默认行高
    rowHeight: {
      type: Number,
      default: 38,
    },
    twoLineHeader: {
      type: Boolean,
      default: false,
    },
    // 标点显示的日期数据, 如：['2020-11-01','2020-11-02']
    eventDays: Array,
    // 初始显示日期
    defaultDate: Date,
    // 今天按钮返回的日期，缺省则使用defaultDate
    toDayDate: {
      type: Date,
      default () {
        return new Date();
      },
    },
  },
  data: () => ({
    // 通过最大最小月份
    // 实现vant calendar组件只显示一月，并可以切换月份的功能
    minDate: "",
    maxDate: "",

    // 标记日历是否已经折叠
    isFolded: false,

    // 当前选中的日期
    chooseDate: "",
    // 当前选中的月
    currentMonth: "",
    subtitle: '',
  }),
  computed: {
    // 根据日历事件生成一个对象
    // 用于formatter快速匹配当前天是否要显示有课图标
    // 可以避免每次都循环this.eventDays数组
    eventDaysObj () {
      let obj = {};
      for(let eventDay of this.eventDays||[]) {
        obj[eventDay] = true;
      }
      return obj;
    },
  },
  created () {
    // 设置当前选中日历，如果父组件未传入刚使用客户端当前时间
    this.chooseDate = this.defaultDate || new Date();
    this.subtitle = app.tool.date.formatDatetime(this.chooseDate, 'yyyy年MM月');
    // 根据当前选中日历设置选中月份
    this.setShowMonth(
      new Date(this.chooseDate).getFullYear(),
      new Date(this.chooseDate).getMonth() + 1);
  },
  methods: {
    // 日期格式化函数
    // 按照vant calendar的方式实现显示日历事件小提示点
    formatter(day) {

      const nowStr = app.tool.date.filterDate(new Date());
      const dayDateStr = app.tool.date.filterDate(day.date);

      // 今日显示今
      if (nowStr === dayDateStr) {
        day.text = "今天";
        day.className = "to-day"
      }
      
      // 如果日历事件无数据，直接返回，不继续向下
      if (!this.eventDays || !this.eventDays.length) return day;

      // 判断是否要显示有课图标
      if (this.eventDaysObj[dayDateStr]) {
        let now = (day.className =
          "has-event-day" +
          (nowStr === dayDateStr ? ' to-day': '') + 
          (new Date(dayDateStr) < new Date(nowStr) ? " gray" : ""));
        day.bottomInfo = "•";
      }

      return day;
    },
    /**
     * 切换上/下月通用方法
     * val为-1表示切换到上月，为1表示切换到下月
     */
    nextMonth(val) {
      let date = this.minDate;
      date.setMonth(date.getMonth() + val);
      this.setShowMonth(date.getFullYear(), date.getMonth() + 1);
    },

    /**
     * 设置日历显示月份
     * 通过设置calendar的minDate、maxDate分别为具体月第一天和最后一天实现
     */
    setShowMonth(year, month) {

      let minDate = new Date(`${year}/${month}/01`);
      let maxDate = new Date(`${year}/${month}/01`);

      // 将最大日期设置为当前月的最后一天
      // 先在1号的基本上加一个月，再减一天，限当月最后一天
      maxDate = new Date(maxDate.setMonth(maxDate.getMonth() + 1));
      maxDate = new Date(maxDate.setDate(maxDate.getDate() - 1));

      // 更新当前日历最小、最大日期
      this.minDate = minDate;
      this.maxDate = maxDate;

      // 更新calendar日历组件显示的月
      this.$refs.calendar &&
        (this.$refs.calendar.subtitle = `${year}年${month}月`);

      // 将当前设置的月转换成yyyy-mm格式
      let newMonth = `${year}-${(month >= 10 ? "" : "0") + month}`;

      // 只有月份发生改变才继续向下执行
      if (this.currentMonth !== newMonth) {

        this.currentMonth = newMonth;
        this.subtitle = newMonth.replace('-','年') + '月';
        // 如果当前日历折叠了，切换月份需要重新计算将那一行显示
        this.isFolded && setTimeout(() => {
          // 找到当月是选中的天
          let choosedDay = this.$el.querySelector(".van-calendar__selected-day");

          // 如果没有选中的天，直接选择每月最中间的日期
          if (!choosedDay) {
            let allDay = this.$el.querySelectorAll(".van-calendar__day");
            choosedDay = allDay[parseInt(allDay.length / 2)];
          }
          
          // 通过找到当前选中的日子，调用dom原生方法"scrollIntoView" 
          choosedDay && choosedDay.scrollIntoView();
        });

        // 向上响应月份切换事件
        this.$emit("monthChange", newMonth);
      }
    },

    // 日期选择事件
    dateSelectHandler(v) {
      this.chooseDate = v;
      this.$emit("chooseDate", v);
    },

    // 调用通用方法，实现通过弹窗选择想要看的月份
    pickerTimeHandler() {
      let maxDate = new Date(this.chooseDate || new Date(this.minDate));
      maxDate = new Date(maxDate.setFullYear(maxDate.getFullYear() + 3));
      app.x3.picker
        .datetime({
          type: "year-month",
          "min-date": new Date("1990/01/01"),
          "max-date": maxDate,
          value: this.chooseDate || new Date(this.minDate),
        })
        .then((res) => {
          let date = new Date(res);
          this.setShowMonth(date.getFullYear(), date.getMonth() + 1);
        });
    },

    /**
     * 通过类名控制，实现折叠效果
     * 通过js将当天选中天出现在当前视图
     */ 
    doFold() {
      // 本段代码，实现把日历的高度变成单行高度
      this.isFolded = !this.isFolded;

      // 在上一行 “实现把日历的高度变成单行高度” 生效后， 通过找到当前选中的日子(如无，选择中间的日期)，
      // 调用dom原生方法"scrollIntoView" 来实现把此行日期显示到上面的单行
      this.$nextTick(() => {
        let choosedDay = this.$el.querySelector(".van-calendar__selected-day");
        if (!choosedDay) {
          let allDay = this.$el.querySelectorAll(".van-calendar__day");
          choosedDay = allDay[parseInt(allDay.length / 2)];
        }
        setTimeout(() => {
          choosedDay && choosedDay.scrollIntoView();
        }, 400);
      });
    },

    // 返回到今天
    backToDefaultDate() {
      if (!this.toDayDate && !this.defaultDate) return false;
      this.chooseDate =  this.toDayDate || this.defaultDate;
      this.setShowMonth(
        new Date(this.chooseDate).getFullYear(),
        new Date(this.chooseDate).getMonth() + 1
      );
      this.$refs.calendar.currentDate = this.chooseDate;
      this.$emit("chooseDate", this.chooseDate);
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule-calendar-container {
  background-color: var(--white);
  position: relative;
  .header-flex {
    width: 100%;
    z-index: 2;

    .sub-title {
      padding: 0 calc(var(--gap) * 12);
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: calc(var(--w) * 44);
      .date-operation-nav{
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: flex-start;
        .center-picker {
          font-weight: var(--bold);
        }
        i {
          font-size:var(--fs-ex1);
          line-height:var(--lh-ex1);
          color: var(--g8);
          &:first-child{
            transform: rotateZ(90deg);
          }
          &:last-child{
            transform: rotateZ(-90deg);
          }
        }
      }
      .to-day-btns {
        display: flex;
        padding: 0 calc(var(--gap) * 8);
        align-items: center;
        justify-content: center;
        height: calc(var(--w) * 24);
        background-color: rgba(var(--c1-rgb), 0.1);
        border-radius: var(--radius-base);
        background-color: rgba(var(--c1-rgb), 0.1);
        color: var(--c1);
        &.is-today{
          color: var(--g5);
          background-color: var(--g1) ;
        }
      }
    }
    .top-nav {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 calc(var(--gap) * 16);

    }
    

  }
  .fold-nav {
    display: flex;
    height: 28px;

    &::before {
      margin: auto;
      content: "";
      width: 40px;
      height: 4px;
      background: #dddddd;
      border-radius: 2px;
    }
  }

}
</style>
<style lang="scss">
@keyframes non-folded {
  0% {
    height: 38px;
  }
  70% {
    height: 200px;
  }
  100% {
    height: auto;
  }
}
@keyframes folded {
  0% {
    height: 200px;
  }
  100% {
    height: 38px;
  }
}
.schedule-calendar-container {
  .van-calendar__day{
    font-size:var(--fs-md);
  }
  .schedule-vant-calendar {
    .van-calendar__header {
      position: relative;
      box-shadow: unset;
      .van-calendar__header-subtitle {
        display: none;
      }
      .van-calendar__weekdays {
        color: var(--g6);
      }
    }
    .van-calendar__body {
      overflow: hidden;
      .van-calendar__selected-day {
        border-radius: var(--radius-sm);
        background-color: var(--c1);
      }
      .van-calendar__month {
        transition: height 3s ease-in;
      }
    }

    .has-event-day {
      .van-calendar__bottom-info {
        font-size: 24px;
        color: var(--c1);
        bottom: 0px;
      }
      &:not(.gray){    
        .van-calendar__selected-day{   
          .van-calendar__bottom-info {
            color: var(--white);
          }
        } 
      }
    }
    .has-event-day.gray {
      .van-calendar__bottom-info {
        color: var(--g5);
        // opacity: 0.85;
      }
    }
  }
  .van-calendar__month {
    animation: non-folded 0.3s;
  }
  &.is-folded {
    .van-calendar__month {
      height: 38px;
      animation: folded 0.3s;
    }
  }

}
</style>
